"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCriteriaType = exports.DiscountCurrency = exports.DiscountRuleType = exports.DiscountType = void 0;
var DiscountType;
(function (DiscountType) {
    DiscountType["KONFEKTIONIERUNG_BASE_PRICE_EK"] = "KonfektionierungBasePriceEK";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var DiscountRuleType;
(function (DiscountRuleType) {
    DiscountRuleType["PERCENTAGE"] = "percentage";
})(DiscountRuleType = exports.DiscountRuleType || (exports.DiscountRuleType = {}));
var DiscountCurrency;
(function (DiscountCurrency) {
    DiscountCurrency["EUR"] = "EUR";
})(DiscountCurrency = exports.DiscountCurrency || (exports.DiscountCurrency = {}));
var DiscountCriteriaType;
(function (DiscountCriteriaType) {
    DiscountCriteriaType["MIN_ITEMS"] = "minItems";
})(DiscountCriteriaType = exports.DiscountCriteriaType || (exports.DiscountCriteriaType = {}));
//# sourceMappingURL=Discount.js.map